import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const ADHDSection = () => {
  return (
    <section className="bg-[#fdfcf9] py-20 px-4 scroll-mt-28" id="adhd">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#d2a391] uppercase text-sm tracking-[0.2em] mb-2">
            Pracownia diagnostyki ADHD
          </p>
          <h2 className="text-3xl md:text-5xl font-alike text-darkGrey">
            Diagnostyka ADHD
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-[#e8e4dc] p-6 md:p-10">
          {/* Główny opis - minimalnie ciemniejszy */}
          <p className="text-[#5f5a54] leading-relaxed text-lg font-light">
            Prowadzimy kompleksową diagnozę zespołu nadpobudliwości psychoruchowej z
            deficytem uwagi (ADHD) u dzieci, młodzieży oraz osób dorosłych. Proces
            diagnostyczny oparty jest na standaryzowanych metodach psychometrycznych,
            szczegółowym wywiadzie klinicznym oraz analizie funkcjonowania pacjenta w
            różnych obszarach życia.
          </p>

          <div className="mt-10">
            <p className="text-darkGrey font-alike text-xl mb-5">
              Wykorzystujemy m.in.:
            </p>

            <ul className="space-y-5 text-[#5f5a54] leading-relaxed">
              <li className="flex gap-4">
                <CheckCircle2 className="text-[#d2a391] mt-1 shrink-0" />
                <span>specjalistyczne kwestionariusze i skale diagnostyczne ADHD</span>
              </li>

              <li className="flex gap-4">
                <CheckCircle2 className="text-[#d2a391] mt-1 shrink-0" />
                <span>
                  testy psychologiczne oceniające uwagę, impulsywność i funkcje wykonawcze
                </span>
              </li>

              <li className="flex gap-4">
                <CheckCircle2 className="text-[#d2a391] mt-1 shrink-0" />
                <span>
                  komputerowy test ciągłej uwagi MOXO, pozwalający na obiektywny pomiar
                  koncentracji, kontroli impulsów oraz reaktywności na bodźce rozpraszające.
                </span>
              </li>
            </ul>

            {/* Zakończenie - też minimalnie ciemniejsze */}
            <p className="mt-10 text-[#5f5a54] leading-relaxed text-lg font-light">
              Diagnoza kończy się szczegółowym omówieniem wyników oraz zaleceniami
              dotyczącymi dalszego postępowania terapeutycznego i edukacyjnego.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ADHDSection;
